import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ListaComponent } from './lista/lista.component';
import { PI_MODULES } from '../pages/base/prime-modules';
import { FormsModule } from '@angular/forms';
import { CabeceraVentanaComponent } from './cabecera-ventana/cabecera-ventana.component';
import { ConfirmationService } from 'primeng/api';
import { OnListaComponent } from './on-lista/on-lista.component';
import { DetalleVentanaComponent } from './detalle-ventana/detalle-ventana.component';
import { DetalleReporteComponent } from './detalle-reporte/detalle-reporte.component';



@NgModule({
  declarations: [
    ListaComponent,
    CabeceraVentanaComponent,
    OnListaComponent,
    DetalleVentanaComponent,
    DetalleReporteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ...PI_MODULES
  ],
  exports: [
    ListaComponent,
    OnListaComponent,
    CabeceraVentanaComponent,
    DetalleVentanaComponent,
    DetalleReporteComponent
  ],
  providers: [
    DatePipe,
    ConfirmationService
  ]
})
export class ComponentsModule { }
